import { Component, Input } from '@angular/core';
import { ElementIntegerModel, ElementModel, Form, FormElement, FormElementValidators, TranslationManager, ViewState } from 'src/common';
import { LocaleService } from 'src/common/services/locale';
import { ElementMode, ElementOrderDirection, ElementViewModel } from '../elements.model';

@Component({
  selector: 'element-integer',
  templateUrl: './element-integer.component.html'
})
export class ElementIntegerComponent {

  @Input() mode: ElementMode = ElementMode.Definition;
  elementMode = ElementMode;
  @Input() state: ViewState;
  @Input() showOrderUp: boolean;
  @Input() showOrderDown: boolean;
  viewState = ViewState;
  form: Form = new Form();
  formValue: Form = new Form();

  translationManager = TranslationManager;
  localeService = LocaleService;

  private _element: ElementViewModel;
  elementOrderDirection = ElementOrderDirection;

  @Input() set element(value: ElementViewModel) {
    this._element = value;
    this._element.isValid = this.isValid.bind(this);
    this._element.isValueValid = this.isValueValid.bind(this);
    this._element.getElement = this.getElement.bind(this);
    this._element.getValue = this.getValue.bind(this);
    this.mapElementToForm();
    this.refreshFormState();
  }

  constructor() {
    this.initForm();
  }

  isValid(): boolean {
    return this.form.isValid();
  }

  isValueValid(): boolean {
    return this.formValue.isValid(FormElementValidators.integerValidator)
  }

  getValue(): any {
    return this.formValue.elements['value'].value;
  }

  getElement(): ElementModel {
    this.mapFormToElement();
    return this._element.element;
  }

  private initForm() {
    this.form.elements['name'] = new FormElement();
    this.form.elements['isMandatory'] = new FormElement();
    this.formValue.elements['value'] = new FormElement();
  }

  private mapElementToForm() {
    let model: ElementIntegerModel = this._element.element.data as ElementIntegerModel;

    this.form.elements['name'].value = model.name;
    this.form.elements['isMandatory'].value = model.isMandatory;
    this.formValue.elements['value'].value = this._element.element.value;
  }

  private refreshFormState() {
    this.form.elements['name'].state.mandatory = this.mode == ElementMode.Definition;
    this.formValue.elements['value'].state.mandatory = this.form.elements['isMandatory'].value;
  }

  private mapFormToElement() {
    let model: ElementIntegerModel = this._element.element.data as ElementIntegerModel;

    model.name = this.form.elements['name'].value;
    model.isMandatory = this.form.elements['isMandatory'].value;
  }

  delete() {
    this._element.delete(this._element);
  }
}
